import { Box } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";
import { Grid } from "@mui/material";

const NoImagePlaceholder = styled.div`
  width: 100%;
  width: 120px;
  height: 120px;
  background-color: ${(p) => p.theme.colors.background2};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.875rem;
  color: ${(p) => p.theme.text.colors.secondary};
  border-radius: none;
  border-radius: 0.5rem;
`;

export const ContactInfoItem = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  text-align: left;
  gap: 0.25rem;
  color: ${(p) => p.theme.text.colors.primary};

  a {
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }

  ${(p) => p.theme.media.tabletDown} {
    justify-content: center;
  }
`;

export const NoAgentAvatarPlaceholder = styled(NoImagePlaceholder)`
  width: 100%;
  height: auto;
  aspect-ratio: 1;
  border-radius: 0.5rem;
`;

export const NoOfficeLogoPlaceholder = styled(NoImagePlaceholder)`
  width: 200px;
  height: 80px;
  border-radius: none;
  border-radius: 0.5rem;
`;

export const ContactCard = styled(Grid)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border: 1px solid ${(p) => p.theme.colors.border2};
  width: 100%;
  max-width: 780px;
  margin: auto;
  min-height: 260px;
  border-radius: 0.5rem;
  background-color: ${(p) => p.theme.colors.background};

  ${(p) => p.theme.media.tabletDown} {
    justify-content: center;
    grid-template-columns: 1fr;
  }
`;

export const LeftCardInfo = styled.div`
  width: 100%;
  padding: 2rem 1rem 1.5rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ${(p) => p.theme.media.tabletDown} {
    align-items: center;
    padding: 2rem 1rem 1rem 1rem;
  }
`;

export const AgentInfoContent = styled.div`
  display: flex;
  gap: 0.125rem;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;

  p {
    word-break: break-all;
    line-height: 100%;
  }

  ${(p) => p.theme.media.tabletDown} {
    align-items: center;
  }
`;

export const ContactInfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 1rem;

  ${(p) => p.theme.media.tabletDown} {
    align-items: center;
  }
`;

export const BrokerageInfoContainer = styled.div`
  text-align: left;

  ${(p) => p.theme.media.tabletDown} {
    text-align: center;
  }
`;

export const BrokerageLogoContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0.5rem;
  min-width: 100px;
  width: 100%;

  img {
    max-width: 240px;
    width: auto;
    height: auto;
    max-height: 80px;
    display: block;
  }

  ${(p) => p.theme.media.tabletDown} {
    display: flex;
    justify-content: center;
    text-align: center;
  }
`;

export const AgentAvatarContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 2rem;
  min-height: 200px;
  width: 100%;
  img,
  > div {
    width: 100%;
    max-width: 280px;
    height: auto;
    border-radius: 0.5rem;
    display: block;
  }

  ${(p) => p.theme.media.tabletDown} {
    justify-content: center;
    align-items: center;
    padding: 0rem 2rem 2rem 2rem;

    img,
    > div {
      max-width: 180px;
    }
  }
`;

export const SocialMediasContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  justify-content: flex-start;
  width: 100%;
  row-gap: 0.5rem;
  column-gap: 1rem;
  max-width: 300px;
  color: ${(p) => p.theme.text.colors.primary};

  a {
    display: flex;
    align-items: flex-start;
    gap: 0.25rem;
    color: ${(p) => p.theme.text.colors.primary};
    text-decoration: none;

    span {
      display: inline-block;
      margin-bottom: 0.25rem;
    }
  }

  a:hover {
    color: ${(p) => p.theme.text.colors.primary};
  }

  ${(p) => p.theme.media.tabletDown} {
    margin: auto;
    align-items: center;
    justify-content: center;
    grid-template-columns: repeat(1, auto);
  }
`;

export const SectionEditWrapper = styled.div`
  position: relative;
  border-radius: 0.5rem;
  padding: 3rem 2rem;

  .top-bar-container {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &:hover .top-bar-container {
    opacity: 1;
  }
`;

export const TopBarContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  top: -0.5rem;
  left: 2rem;
  right: 2rem;
  padding: 0 0.5rem 0 1rem;
  z-index: 2;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
